import React, { useEffect, useState } from 'react';
import Page from '../../components/Page';
import { getDatabase, ref, onValue } from 'firebase/database';
import {
    CircularProgress,
    Container,
    Fade,
    IconButton,
    Tooltip,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import MUIDataTable from 'mui-datatables';
import Title from '../../components/Title';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { columns, FAQsOptions } from './FAQsTable';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
    },
    container: {
        paddingTop: 47,
    },
    '@global': {
        html: {
            width: '100%',
            height: '100%',
        },
    },
}));

const FAQs = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const options = FAQsOptions(faqs);

    useEffect(() => {
        const db = getDatabase();
        const reference = ref(db, 'faqs');
        const unsubscribe = onValue(reference, (snapshot) => {
            let result = [];

            snapshot.forEach((item) => {
                result.push({ ...item.val(), id: item.key });
            });
            setFaqs(result);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    return (
        <Page className={classes.root} title={'FAQs'}>
            <Container maxWidth={false} className={classes.container}>
                <Title
                    title="FAQs"
                    button={
                        <Tooltip title="Afegir FAQ">
                            <IconButton
                                className={classes.addButton}
                                onClick={() => navigate('nou')}
                            >
                                <Add />
                            </IconButton>
                        </Tooltip>
                    }
                />
                {loading ? (
                    <CircularProgress />
                ) : (
                    <Fade in={!loading}>
                        <div>
                            <MUIDataTable
                                data={faqs}
                                columns={columns}
                                options={options}
                            />
                        </div>
                    </Fade>
                )}
            </Container>
        </Page>
    );
};

export default FAQs;
